import { useState } from "react";
import { GroupCreationFormCategoriesValues } from "./group-creation-form-categories";
import { GroupCreationFormDetailsValues } from "./group-creation-form-details";
import { GroupCreationFormImagesValues } from "./group-creation-form-images";

const steps = ['details', 'categories', 'images', 'publish', 'share'] as const

type GroupCreationWizardStep = typeof steps[number]

export type GroupCreationFormData = GroupCreationFormDetailsValues &
  GroupCreationFormCategoriesValues & GroupCreationFormImagesValues

type GroupCreationWizardState = {
  step: GroupCreationWizardStep
} & GroupCreationFormData


export const initialState: GroupCreationWizardState = {
  step: 'details',
  name: '',
  description: '',
  visibility: 'public',
  mainCategory: {
    label: '',
    value: '',
  },
  subCategories: [],
  coverImage: null,
  profileImage: null,
}

export const useGroupCreationWizard = () => {
  const [step, setStep] = useState<GroupCreationWizardStep>('details');
  const [formData, setFormData] = useState<GroupCreationFormData>(initialState);

  const goBack = () => {
    const currentIndex = steps.indexOf(step);
    const previousStep = steps[currentIndex - 1];
    if (previousStep) {
      setStep(previousStep);
    }
  };

  const updateStep = (newStep: GroupCreationWizardStep) => {
    setStep(newStep);
  };

  const updateFormData = (details: Partial<GroupCreationFormData>) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...details,
    }));
  };

  const reset = () => {
    setStep('details');
    setFormData(initialState);
  };

  return { formData, step, goBack, updateStep, updateFormData, reset };
}